var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArchiveAppBtn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 119,
    height: 35,
    viewBox: "0 0 119 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Edit_Category",
    transform: "translate(-307.283 -198.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10413",
    "data-name": "Group 10413"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_55",
    "data-name": "Rectangle 55",
    width: 119,
    height: 35,
    rx: 4,
    transform: "translate(307.283 198.5)",
    fill: "#74531b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7881",
    "data-name": "Group 7881",
    transform: "translate(349.283 207)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Archive_App",
    "data-name": "Archive App",
    transform: "translate(0 13)",
    fill: "#fff",
    fontSize: 12,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Archive App"))), /*#__PURE__*/React.createElement("g", {
    id: "Archive_Icon",
    transform: "translate(2475.283 299)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11150",
    "data-name": "Group 11150",
    transform: "translate(-2151.304 -88.283)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36396",
    "data-name": "Path 36396",
    d: "M6.7.457H0V-.5H6.7Z",
    transform: "translate(2.87 6.239)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_885",
    "data-name": "Ellipse 885",
    d: "M6.217,1a5.217,5.217,0,1,0,5.217,5.217A5.223,5.223,0,0,0,6.217,1m0-1A6.217,6.217,0,1,1,0,6.217,6.217,6.217,0,0,1,6.217,0Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "np_folder_1594035_000000",
    d: "M16.015,18.5h4.752A2.529,2.529,0,0,1,22.778,19.5l.815,1.088a1.567,1.567,0,0,0,1.247.622h11.54a2.518,2.518,0,0,1,2.515,2.515V37.985A2.518,2.518,0,0,1,36.379,40.5H16.015A2.518,2.518,0,0,1,13.5,37.985V21.015A2.518,2.518,0,0,1,16.015,18.5ZM36.379,39.543a1.56,1.56,0,0,0,1.558-1.558V23.73a1.56,1.56,0,0,0-1.558-1.558H24.839a2.529,2.529,0,0,1-2.012-1.005l-.815-1.088a1.567,1.567,0,0,0-1.247-.622H16.015a1.56,1.56,0,0,0-1.558,1.558V37.985a1.56,1.56,0,0,0,1.558,1.558Z",
    transform: "translate(-2171.5 -113)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchiveAppBtn);
export default __webpack_public_path__ + "static/media/archive_app_btn.dd02911a.svg";
export { ForwardRef as ReactComponent };